import React from "react";

const Index = () => {
	return <div>Logging Out...</div>;
};

export default Index;
